<template>
  <el-dialog :visible.sync="dialogVisible" width="640px" :before-close="handleClose" :close-on-click-modal="false" :modal="false">
    <div slot="title"></div>
    <div style="min-height: 550px;" v-loading = "loading">
      <div class="dialog_title">
        <div class="dialog_title_left">
          <div class="title_item" :class="{ 'title_item_active': tabIndex === index }" v-for="(tab, index) in treeList"
            :key="tab.id" @click="tabChange(index)">{{ tab.speciesName }}</div>
        </div>
        <i class="el-icon-close" @click="handleClose"></i>
      </div>
      <div class="dialog_content" v-if="treeList.length > 0">
        <div class="dialog_content_left">
          <div class="dialog_content_left_item" :class="{ 'content_left_item_active': leftIndex === itemIndex }"
            v-for="(item, itemIndex) in treeList[tabIndex].childrenSet" :key="item.id" @click="leftChange(itemIndex)">
            <div>{{ item.speciesName }}</div>
            <div class="content_left_item_num" v-if="item.num && item.num > 0">{{ item.num }}</div>
          </div>
        </div>
        <div class="dialog_content_right">
          <div class="dialog_content_right_list">
            <div class="content_right_item"
              :class="{ 'content_right_item_active': computedAcupointActive(obj.acupointId) }"
              v-for="obj in treeList[tabIndex].childrenSet[leftIndex].hospAcupointInfoSet" :key="obj.acupointId"
              @click="chooseAcupoint(obj)">{{ obj.acupointName }}
            </div>
          </div>
        </div>
      </div>
      <div class="dialog_bottom">
        <div class="dialog_bottom_left">
          <div class="dialog_bottom_left_item" v-for="(chooseObj, chooseIndex) in chooseList"
            :key="chooseObj.acupointId">
            <span>{{ chooseObj.acupointName }}</span>
            <i class="el-icon-close" @click="deleteAcupoint(chooseIndex)"></i>
          </div>
        </div>
        <div class="dialog_bottom_right">
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { listAcupointSpecies } from '@/api/acupoint'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    chooseList:{
      type: Array,
      default: () => {
        return []
      }
    },
    acupointDialogObj:{
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  watch:{
    acupointDialogObj:{
      deep:true,
      immediate:true,
      handler(){
        this.tabIndex = this.acupointDialogObj.tabIndex
      }
    }
  },
  data() {
    return {
      treeList: [],
      leftIndex: 0,
      loading:false,
      tabIndex:0
    };
  },
  
  computed: {
    computedAcupointActive() {
      let that = this
      return function (acupointId) {
        let index = this.chooseList.findIndex(v => { return v.acupointId === acupointId })
        return index > -1 ? true : false;
      }
    },
  },
  created() {
    this.getData()
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    getData() {
      this.loading = true
      listAcupointSpecies({ queryAcupoint: true }).then(res => {
        if (res.code == 200) {
          this.treeList = res.data
          this.calculateLeftNum()
        }
        this.loading=false
      })
    },
    tabChange(index) {
      this.tabIndex = index
      this.leftIndex = 0
    },
    leftChange(leftIndex) {
      this.leftIndex = leftIndex
    },
    deleteAcupoint(index) {
      this.chooseList.splice(index, 1)
      this.calculateLeftNum()
    },
    chooseAcupoint(obj) {
      let acupoint = { parentId: this.treeList[this.tabIndex].childrenSet[this.leftIndex].id, ...obj }
      let index = this.chooseList.findIndex(v => { return v.acupointId == acupoint.acupointId })
      index > -1 ? this.chooseList.splice(index, 1) : this.chooseList.push(acupoint)
      this.calculateLeftNum()
    },
    calculateLeftNum() {
      this.treeList.forEach(v1 => {
        v1.childrenSet.forEach(v2 => {
          let num = 0
          v2.hospAcupointInfoSet.forEach(v3 => {
            this.chooseList.forEach(v4 => {
              if(v3.acupointId == v4.acupointId){
                num ++
              }
            })
          })
          v2.num = num
        })
      })
    },
    confirm(){
      let obj = {
        chooseList:this.chooseList,
        ...this.acupointDialogObj
      }
      this.$emit('accupointConfirm',obj)
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  display: none;
}
/deep/.el-dialog__body{
  padding: 0;
}
.dialog_title {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 0 16px;
  border-bottom: 1px solid #E0E0E0;
}

.dialog_title_left {
  display: flex;

}

.dialog_title .el-icon-close {
  font-size: 14px;
  color: #A4AFBA;
}

.title_item {
  color: #667182;
  font-size: 14px;
  margin-right: 24px;
  cursor: pointer;
}

.title_item_active {
  color: #000000;
  font-weight: 500;
  position: relative;

  &::after {
    content: '';
    display: inline-block;
    width: 56px;
    height: 0px;
    border: 2px solid #1890FF;
    position: absolute;
    left: 0;
    bottom: -17px;
  }
}

.dialog_content {
  display: flex;
  height: 448px;
  overflow: hidden;
}

.dialog_content_left {
  width: 160px;
  border-right: 1px solid #E0E0E0;
  overflow: auto;
  padding-top: 6px;
  background: #FAFBFC;
  flex-shrink: 0;
  box-sizing: border-box;
}

.dialog_content_left_item {
  height: 34px;
  padding: 0 16px;
  line-height: 34px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  .content_left_item_num {
    color: #1890FF;
  }
}

.content_left_item_active {
  background: #E8F4FF;

  .content_left_item_num {
    color: #1890FF !important;
  }
}

.dialog_content_right {
  background: #fff;
  width: 100%;
  overflow: auto;
}

.dialog_content_right_list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5,1fr);
  grid-template-rows: 36px;
}

.content_right_item {
  background: #FFFFFF;
  border-right: 1px dashed #E0E0E0;
  border-bottom: 1px dashed #E0E0E0;
  color: #000;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
  box-sizing: border-box;
  cursor: pointer;
  &:hover{
    background: #F7F8F9;
  }
}

.content_right_item_active {
  background: #F7F8F9;
  color: #1890FF;
}

.dialog_bottom {
  padding: 16px;
  border-top: 1px solid #E0E0E0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog_bottom_left {
  width: 490px;
  display: flex;
  flex-wrap: wrap;
}

.dialog_bottom_left_item {
  height: 20px;
  border: 1px solid #1890FF;
  border-radius: 23px;
  padding: 0 8px;
  color: #1890FF;
  font-size: 13px;
  line-height: 20px;
  margin-right: 12px;
  margin-bottom: 8px;
  position: relative;

  &:hover {
    .el-icon-close {
      display: block;
    }
  }
}

.dialog_bottom_left_item .el-icon-close {
  cursor: pointer;
  display: none;
  position: absolute;
  top: -5px;
  right: -10px;
  color: #A4AFBA;
  font-size: 16px;
  background: #EBECED;
  border-radius: 50%;
}
</style>